import { CmsContentPageContainerLoadable } from 'modules/cms/pages/Content';
import { CmsDashboardApiPage } from 'modules/cmsDashboard/api/types/CmsDashboardApiPage';
import { SearchPageContainerLoadable } from 'modules/main/pages/Search';
import { WithRouterParams } from 'utils/WithRouterParams';
import { hasParam } from 'utils/url';

type Args = {
  content: CmsDashboardApiPage | undefined;
  amp: boolean;
};

export function getCmsComponent({ content, amp }: Args) {
  return (
    <WithRouterParams
      render={(routeParams, location) => {
        const prefix = amp ? /^\/amp\// : /^\//;
        const slug = location.pathname.replace(prefix, '');
        const isLandingPage =
          (content &&
            ['CMS_SEARCH_LANDING_PAGE', 'LANDING_PAGE'].includes(
              content.type,
            )) ||
          false;

        const { redirectToContent = false }: { redirectToContent?: boolean } =
          location.state || {};

        if (
          hasParam(location.search, 'q') ||
          hasParam(location.search, 'pq') ||
          isLandingPage
        ) {
          if (redirectToContent) {
            return <CmsContentPageContainerLoadable slug={slug} amp={amp} />;
          }
          return <SearchPageContainerLoadable slug={slug} amp={amp} />;
        }

        return <CmsContentPageContainerLoadable slug={slug} amp={amp} />;
      }}
    />
  );
}
